<template>
  <CustomButton
    :disabled="!isMounted"
    type="raw"
    :aria-label="$t('Cart')"
    data-testid="cartIcon"
    @click="$emit('click')"
  >
    <span
      class="text-xl relative text-EXPONDO-primary lg:mr-3 flex items-center"
    >
      <span class="iconify svg--shopping-cart" />
      <span
        v-if="cartTotalItems"
        :class="{[iconWithDotClasses]: isCartWithDot}"
        class="cart-badge absolute -top-1.5 -right-1"
        data-testid="cartBadge"
      >
        {{ cartTotalItems }}
      </span>
    </span>
    <div class="text-left hidden text-EXPONDO-primary lg:block">
      <p class="font-bold">
        {{ $t('Cart') }}
      </p>
      <p class="text-xs font-normal">
        {{ $t('Checkout') }}
      </p>
    </div>
  </CustomButton>
</template>

<script lang="ts">

import { cartGetters } from '~/utils/ct';

export default defineComponent({
  name: 'CartIcon',

  props: {
    isCartWithDot: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup() {

    const { cart } = useCartExtended();
    const { isMounted } = useIsMounted();
    const cartTotalItems = computed(() => {

      const count = cartGetters.getTotalItems(cart.value);

      return count ? count.toString() : null;
    
    });

    const iconWithDotClasses = `cart-badge--with-dot text-EXPONDO-white w-4 h-4 rounded-full
    bg-EXPONDO-red text-sm flex items-center justify-center`;

    return {
      cartTotalItems,
      iconWithDotClasses,
      isMounted,
    };
  
  },
});

</script>

<style lang="scss" scoped>
.cart-badge {
  font-family: var(--font-family--primary);
}
</style>
